var map = {
	"../pages/address/address.module": [
		856,
		0
	],
	"../pages/block-detail/block-detail.module": [
		857,
		1
	],
	"../pages/blocks/blocks.module": [
		325
	],
	"../pages/broadcast-tx/broadcast-tx.module": [
		467
	],
	"../pages/home/home.module": [
		472
	],
	"../pages/statistic/statistic.module": [
		469
	],
	"../pages/transaction/transaction.module": [
		858,
		2
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 225;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 225
// module chunks = 3